import axios, { AxiosError } from 'axios';
import { Api } from '../../axiosApi';

interface ItemVenda {
  qtds: number;
  idmov: string;
  descricao: string;
  referencia: string;
  un: string;
  preco: number;
  total: number;
}
interface RomaneioVenda {
  idmov: string;
  emissao: string;
  numero: string | null;
  idparceiro: string;
  idoperacao: string;
  nome: string;
  cpf: string;
  descricao: string;
  tpag: string;
  vprod: number;
  desconto: number;
  acrescimo: number;
  total: number;
}
export interface Rreceber {
  romaneios: RomaneioVenda;
  itens: ItemVenda[];
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}
const Rreceber = async (
  parceiro: string,
  datainicial: string,
  datafinal: string
): Promise<Rreceber[] | Error> => {

  try {

    const urlRelativa =
      `/relatoriocontasreceber?parceiro=${parceiro}&datainicial=${datainicial}&datafinal=${datafinal}`;

    const { data } = await Api.get<Rreceber[]>(urlRelativa);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o relatório de vendas.');

  } catch (error) {

    if (axios.isAxiosError(error)) {

      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {

        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';

        return new Error(errorMessage);

      } else if (axiosError.request) {

        return new Error('Nenhuma resposta do servidor');

      } else {

        return new Error(axiosError.message);

      }

    }

    return new Error('Erro inesperado');
  }
};

const Rrecebidas = async (
  parceiro: string,
  conta: string,
  datainicial: string,
  datafinal: string
): Promise<Rreceber[] | Error> => {

  try {

    const urlRelativa =
      `/relatoriocontasrecebidas?parceiro=${parceiro}&conta=${conta}&datainicial=${datainicial}&datafinal=${datafinal}`;
    const { data } = await Api.get<Rreceber[]>(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o relatório de vendas.');

  } catch (error) {

    if (axios.isAxiosError(error)) {

      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {

        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';

        return new Error(errorMessage);

      } else if (axiosError.request) {

        return new Error('Nenhuma resposta do servidor');

      } else {

        return new Error(axiosError.message);

      }

    }

    return new Error('Erro inesperado');
  }
};



const Rpagar = async (
  parceiro: string,
  planoconta: string,
  agrupar: string,
  datainicial: string,
  datafinal: string
): Promise<Rreceber[] | Error> => {

  try {

    const urlRelativa =
      `/relatoriocontaspagar?parceiro=${parceiro}&planoconta=${planoconta}&agrupar=${agrupar}&datainicial=${datainicial}&datafinal=${datafinal}`;
    const { data } = await Api.get<Rreceber[]>(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o relatório de vendas.');

  } catch (error) {

    if (axios.isAxiosError(error)) {

      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {

        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';

        return new Error(errorMessage);

      } else if (axiosError.request) {

        return new Error('Nenhuma resposta do servidor');

      } else {

        return new Error(axiosError.message);

      }

    }

    return new Error('Erro inesperado');
  }
};


const Rpagas = async (
  parceiro: string,
  planoconta: string,
  datainicial: string,
  datafinal: string
): Promise<Rreceber[] | Error> => {

  try {

    const urlRelativa =
      `/relatoriocontaspagas?parceiro=${parceiro}&planoconta=${planoconta}&datainicial=${datainicial}&datafinal=${datafinal}`;
    const { data } = await Api.get<Rreceber[]>(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o relatório de vendas.');

  } catch (error) {

    if (axios.isAxiosError(error)) {

      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {

        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';

        return new Error(errorMessage);

      } else if (axiosError.request) {

        return new Error('Nenhuma resposta do servidor');

      } else {

        return new Error(axiosError.message);

      }

    }

    return new Error('Erro inesperado');
  }
};


export const RelatorioFinanceiroService = {
  Rreceber,
  Rrecebidas,
  Rpagar,
  Rpagas
};